import "./Writer.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import image1 from "../../assets/pub1.png";
import image2 from "../../assets/pub2.png";
import image3 from "../../assets/pap1.png";
import paper1 from "../../assets/documents/DESIGN, FABRICATION AND PERFORMANCE EVALUATION OF WASTE PLASTIC SHREDDER.pdf";
import paper2 from "../../assets/documents/DesignandFabricationofaFirefightingDevice.pdf";

function Writer() {
  function notification() {
    new Notification("Paper Downloaded", {
      body: `The selected paper has been downloaded to your local device storage`,
    });
  }

  return (
    <div className="writer">
      <div style={{ minHeight: "1px" }}></div>
      <Header />
      <div className="writer_body">
        <section className="developer_section_one">
          <div>
            <div>
              <h1>Publications.</h1>
            </div>
          </div>
        </section>
        <section className="writer_section_one">
          {/* <div className="writer_section_one_div1">
            <h3>Academic Publications</h3>
          </div> */}
          <div className="writer_section_one_div2">
            <div>
              <a href={paper1} download target="_blank" onClick={notification}>
                <img src={image1} className="writer_image" />
              </a>
              <h3>
                Design, fabrication and performance evaluation of a waste platic
                shredder
              </h3>
            </div>
            <div>
              <a href={paper2} download target="_blank" onClick={notification}>
                <img src={image2} className="writer_image" />
              </a>
              <h3>Design and fabrication of a fire-fighting robot</h3>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Writer;
